import { Component } from '@theme/component';
class ChristmasSets extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    this.refs.track?.addEventListener('scroll', () => this.update(), { passive: true, signal: this.abort.signal });
    this.observer?.disconnect();
    this.observer = new ResizeObserver(() => { this.alignDetails(); this.update(); });
    if (this.refs.track) this.observer.observe(this.refs.track);
    this.alignDetails();
    document.fonts.ready.then(() => { if (this.isConnected) this.alignDetails(); });
    this.update();
  }
  updatedCallback() { super.updatedCallback(); this.update(); }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); super.disconnectedCallback(); }
  alignDetails() {
    const track = this.refs.track;
    if (!track) return;
    const titles = [...track.querySelectorAll('[ref="productTitleLink"] .text-block')];
    const contents = [...track.querySelectorAll('.zc-set-contents')];
    track.style.setProperty('--zc-title-height', '0px');
    track.style.setProperty('--zc-contents-height', '4.35em');
    const titleHeight = Math.max(0, ...titles.map(el => el.getBoundingClientRect().height));
    const contentHeight = Math.max(0, ...contents.map(el => el.getBoundingClientRect().height));
    track.style.setProperty('--zc-title-height', `${Math.ceil(titleHeight)}px`);
    track.style.setProperty('--zc-contents-height', `${Math.ceil(contentHeight)}px`);
  }
  update() {
    const { track, controls, status, previous, next } = this.refs;
    if (!track || !controls || !track.children.length) return;
    const cards = [...track.children], rect = track.getBoundingClientRect();
    const visible = cards.map((card, i) => ({ i, r: card.getBoundingClientRect() })).filter(({ r }) => r.left >= rect.left - 3 && r.right <= rect.right + 3);
    const first = visible[0]?.i ?? 0, last = visible.at(-1)?.i ?? first;
    controls.hidden = track.scrollWidth <= track.clientWidth + 3;
    const label = `${first + 1}-${last + 1} ${this.dataset.of} ${cards.length}`;
    if (status.textContent !== label) status.textContent = label;
    previous.disabled = first === 0;
    next.disabled = last === cards.length - 1;
  }
  move(direction) {
    const track = this.refs.track;
    if (!track?.children.length) return;
    const step = track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
    const count = Math.max(1, Math.round(track.clientWidth / step));
    track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  previous() { this.move(-1); }
  next() { this.move(1); }
}
if (!customElements.get('zaltify-christmas-sets')) customElements.define('zaltify-christmas-sets', ChristmasSets);


